import {styled} from '@linaria/react';

type BadgesPosition = 'top-start' | 'bottom-start';

export const BadgesContainer = styled.div<{
  badgesPosition?: BadgesPosition;
  bottomSpace?: boolean;
  bottomStartExtraSpace?: boolean;
}>`
  width: 100%;
  position: absolute;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  transform: translateZ(0);

  top: ${({badgesPosition}) =>
    badgesPosition === 'bottom-start' ? 'auto' : '20px'};

  bottom: ${props => {
    if (props.badgesPosition === 'bottom-start') {
      return props.bottomStartExtraSpace ? '37px' : '20px';
    }

    return 'unset';
  }};

  > li {
    margin-bottom: 5px;
    white-space: nowrap;
  }

  // may need to leave extra margin bottom for the badges list because they get hidden when the countdown timer is running
  margin-bottom: ${({bottomSpace}) => (bottomSpace ? '25px' : '0')};
`;
